import { OAUTH_SESSION_KEYS } from '../screens/Oauth/constants';

/**
 * This function is to align backend and frontend oauth flow
 * It checks where the redirection came from and what is the current state of the UI
 * During alignment, we are saving interaction uid to not create a new one on second redirection.
 */
export const switchEnvFromAppName = ({ appName, isUsEnv, switchUrl, oauthInteractionUid }) => {
  // Save switch URL
  if (switchUrl) {
    sessionStorage.setItem(OAUTH_SESSION_KEYS.SWITCH_ENV_PATH, switchUrl);
  }
  // REACT_APP_API_BASE_URL / REACT_APP_US_API_BASE_URL always end with `/`,
  // so strip a leading `/` from switchUrl to avoid a double slash when joined.
  const normalizedSwitchUrl = switchUrl?.startsWith('/') ? switchUrl.slice(1) : switchUrl;
  // Redirected from US BE
  if (appName === process.env.REACT_APP_US_APP_NAME) {
    // Save US Interaction
    sessionStorage.setItem(OAUTH_SESSION_KEYS.US_SESSION_INTERACTION, oauthInteractionUid);

    // Handle unaligned BE (US) and FE (ROW) env
    if (!isUsEnv) {
      // Get Saved Interaction Uid
      const savedInteractionUid = sessionStorage.getItem(
        OAUTH_SESSION_KEYS.ROW_SESSION_INTERACTION
      );
      if (!savedInteractionUid) {
        // Handle first time switch
        window.location.href = `${process.env.REACT_APP_API_BASE_URL}${normalizedSwitchUrl}`;
      } else {
        // Handle second switch
        const url = new URL(window.location.href);
        url.searchParams.set('app', process.env.REACT_APP_ROW_APP_NAME);
        window.location.href = url.toString();
      }

      return { shouldSubmit: false };
    }
  }
  // Redirected from ROW BE
  if (appName === process.env.REACT_APP_ROW_APP_NAME) {
    // Save ROW Interaction
    sessionStorage.setItem(OAUTH_SESSION_KEYS.ROW_SESSION_INTERACTION, oauthInteractionUid);

    // Handle unaligned BE (ROW) and FE (US) env
    if (isUsEnv) {
      // Get Saved Interaction Uid
      const savedInteractionUid = sessionStorage.getItem(OAUTH_SESSION_KEYS.US_SESSION_INTERACTION);
      if (!savedInteractionUid) {
        // Handle first time switch
        window.location.href = `${process.env.REACT_APP_US_API_BASE_URL}${normalizedSwitchUrl}`;
      } else {
        // Handle second switch
        const url = new URL(window.location.href);
        url.searchParams.set('app', process.env.REACT_APP_US_APP_NAME);
        window.location.href = url.toString();
      }

      return { shouldSubmit: false };
    }
  }

  return {
    shouldSubmit: true,
  };
};

export const getEnvByAppName = (appName) => ({
  isUs: appName === process.env.REACT_APP_US_APP_NAME,
});
